// Scenarios describe player slots and tactics, never team identities or kits.
export function withoutScenarioTeams(value) {
  if (Array.isArray(value)) return value.map(withoutScenarioTeams);
  if (!value || typeof value !== 'object' || (Object.getPrototypeOf(value) !== Object.prototype && Object.getPrototypeOf(value) !== null)) return value;
  return Object.fromEntries(Object.entries(value).filter(([key]) => !['homeTeamId', 'awayTeamId', 'homeTeamName', 'awayTeamName', 'homeTeam', 'awayTeam', 'teams', 'teamId', 'teamName', 'teamData'].includes(key)).map(([key, item]) => [key, withoutScenarioTeams(item)]));
}
